<div class="fx-manager-direct card bg-dark-lighter text-white">
  <div class="card-body">
    <div class="row">
      <div class="col fs-16">
        <span>{{ "Manage Direct User Setting" }}</span>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-6 col-xs-12">
        <div class="input-group search-group">
          <input
            type="text"
            class="form-control bg-dark"
            name="keyword"
            [(ngModel)]="keyword"
            (keyup)="search($event)"
            placeholder="Search"
          />
          <button class="btn btn-main" type="button" (click)="search(null)">
            Search
          </button>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-12 col-xs-12">
        <div class="table-responsive">
          <table class="rox-table table-bordered bg-dark">
            <thead>
              <tr>
                <th class="text-center">ID</th>
                <th class="text-center">Name</th>
                <th class="text-center">Email</th>
                <th class="text-center">Current Setting</th>
                <th class="text-center" *ngIf="permission.allowCreating"></th>
                <th class="text-center" *ngIf="permission.allowCreating"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of traderSetting">
                <td class="text-center">{{ item.id }}</td>
                <td class="text-center">{{ item.getUsername() }}</td>
                <td class="text-center">{{ item.email }}</td>
                <td class="text-center">
                  <select
                    class="{{
                      !permission.allowCreating ? 'ignore-click' : ''
                    }}"
                  >
                    <option *ngFor="let g of item.groups">
                      <span labelGroup="{{ g.groupName }}"></span>
                    </option>
                  </select>
                </td>
                <td class="text-center" *ngIf="permission.allowCreating">
                  <a
                    href="javascript: void(0);"
                    (click)="onTraderSetting(item)"
                    data-bs-toggle="modal"
                    data-bs-target="#modalDirectUserSetting"
                    >Add Setting</a
                  >
                </td>
                <td class="text-center" *ngIf="permission.allowCreating">
                  <a
                    href="javascript:void(0)"
                    class="text-blue-lighter"
                    (click)="getGroupInfo(item)"
                    data-bs-toggle="modal"
                    data-bs-target="#modalAsset"
                    >View</a
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade fx-modal" id="modalAsset">
    <div class="modal-dialog modal-xl modal-dialog-centered modal-shadow">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <h2 class="modal-title font-bold" style="margin-bottom: 0">
            {{ configInfo.name }}
          </h2>
          <button
            type="button"
            class="close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            &times;
          </button>
        </div>

        <!-- Modal body -->
        <div class="modal-body ">
          <table class="rox-table table-bordered bg-dark" *ngIf="configInfo.data">
            <thead>
              <tr>
                <th class="text-center">No</th>
                <th class="text-center">MT5 Group</th>
<!--                <th class="text-center">Commission (%)</th>-->
<!--                <th class="text-center">Pip</th>-->
<!--                <th class="text-center">Percentage (%)</th>-->
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of configInfo.data; let i = index">
                <td class="text-center">{{ i }}</td>
                <td class="text-center">
                  <span labelGroup="{{ item.groupName }}"></span>
                </td>
<!--                <td class="text-center">{{ item.data.commission }}</td>-->
<!--                <td class="text-center">{{ item.data.pip }}</td>-->
<!--                <td class="text-center">-->
<!--                  {{ item.data.rate }}-->
<!--                </td>-->
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <!--<button class="btn btn-primary fs-16" data-bs-toggle="modal" data-bs-target="#modalDirectUserSetting"-->
  <!--(click)="onCampaignSetting()">Add Setting</button>-->

  <!-- CHANGE GROUP NAME MODAL -->
  <div class="modal fade fx-modal" id="modalDirectUserSetting" #modalUser>
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Direct User Setting</h4>
          <button type="button" class="close" data-bs-dismiss="modal">
            &times;
          </button>
        </div>

        <!-- Modal body -->
        <div class="modal-body mb-3">
          <form
            class="form mat-form"
            #formDirect="ngForm"
            autocomplete="off"
            (ngSubmit)="onSubmitTraderSetting()"
          >
            <div class="row">
              <mat-form-field
                appearance="fill"
                floatLabel="auto"
                style="padding: 0 15px"
              >
                <mat-label>MT5 Group</mat-label>
                <mat-select name="group" [(ngModel)]="setting.group" required>
                  <mat-option
                    *ngFor="let item of listTradeConfig"
                    [value]="item.id"
                  >
                    <span labelGroup="{{ item.name }}"></span>
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="w-100 text-center">
              <button type="submit" class="btn btn-main w-50">Apply</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
